import styles from './confirmEmail.module.css';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import supabase from '../../utils/supabase';

export default function ConfirmEmail() {
  const navigate = useNavigate();

  useEffect(() => {
    const { data: subscription } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        if (session?.user) {
          navigate(`/profile/${session.user.id}`);
        }
      },
    );

    return () => {
      subscription.subscription.unsubscribe();
    };
  }, [navigate]);

  return (
    <section className={styles.confirmEmailSection}>
      <div className={`${styles.confirmEmailContainer} container`}>
        <h1>Підтвердіть email</h1>
        <p>
          Ми відправили лист з підтвердженням на вашу пошту. <br />
          Будь ласка, перейдіть за посиланням у листі, щоб активувати акаунт.
        </p>
      </div>
    </section>
  );
}
